import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import ClipLoader from "react-spinners/ClipLoader";
import AddIcon from '@mui/icons-material/Add';
import { useLocation, useNavigate } from "react-router-dom";

import img6 from '../../../../Assets/add/img6.png'
import { Alert } from '@mui/material';

import rightArrow from '../../../../Assets/navbar/right-arrow.svg'
// import rightarrow from '../../../../Assets/navbar/right-arrow.svg'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';


import { useModal } from "../../../../context/ModalContext";
import { motion, AnimatePresence } from "framer-motion";
import { Box, Calendar, ChevronDown, ChevronUp, FileText, Shield, ShowerHead, Trash, Trash2, Truck, Upload, X } from 'lucide-react';

const config = {
    cUrl: 'https://api.countrystatecity.in/v1/countries/IN',
    ckey: 'NHhvOEcyWk50N2Vna3VFTE00bFp3MjFKR0ZEOUhkZlg4RTk1MlJlaA=='
};

const AddNewVehicleDetails = () => {
    const { state } = useLocation();
    const navigate = useNavigate()
    console.log("Received:", state?.mobileNo);
    const [states, setStates] = useState([]);
    const [cities, setCities] = useState([]);
    const [isLoadingStates, setIsLoadingStates] = useState(true);
    const [isLoadingCities, setIsLoadingCities] = useState(true);
    const [alertInfo, setAlertInfo] = useState({ show: false, message: '', severity: 'info' });
    const [isOpenImage, setIsOpenImage] = useState({});
    const [showVehicleInput, setShowVehicleInput] = useState(false);
    const [inputValue, setInputValue] = useState('');
    const [vehicleInputs, setVehicleInputs] = useState([]);
    const [storedVehicleNos, setStoredVehicleNos] = useState([]);
    const [tempVehicleNo, setTempVehicleNo] = useState(""); // temporary input
    const vehicleNoRegex = /^[A-Z]{2}[0-9]{1,2}[A-Z]{1,3}[0-9]{4}$/;
    const [openValidationModal, setOpenValidationModal] = useState(false);

    const [formData, setFormData] = useState({
        loginMobile: '',
        vehicleNo: [],
        vendorName: "",
        city: "",
        state: "",
        vendorPhone: "",
        fatherName: '',
        address: '',
        companyName: ''
    });
    console.log('formdata', formData)
    const [images, setImages] = useState({});
    console.log('images', images)

    const [typeOfAgreement, setTypeOfAgreement] = useState('individual')
    const [isModalOpen, setIsModalOpen] = useState(true);
    const [nextPage, setNextPage] = useState(1);

    useEffect(() => {
        if (state?.value == 'additional-vehicles') {
            setIsModalOpen(false)
            setTypeOfAgreement(localStorage.getItem('typeOfAgreement'))
            // if (localStorage.getItem('typeOfAgreement') == 'non-individual') {
            setNextPage(3)
            // }
        }
    }, [state])

    useEffect(() => {
        if (state?.value !== 'additional-vehicles') {
            localStorage.setItem("typeOfAgreement", typeOfAgreement);
        }
    }, [typeOfAgreement])


    const [imageKeys, setImageKeys] = useState([
        "Photo of the Owner",
        "Adhar Card Front",
        "Adhar Card Back",
        "Pan Card",
        "Cancelled cheque",
        "MOA",
        "Partnership Deed or Company Registration Certificate",
        "GST",


        ...Array.from({ length: 0 }, (_, i) => `image${i + 1}`),
    ]);

    const [imageKeysForVehicle, setImageKeysForVehicle] = useState([
        'Driver DL',
        "RC",
        "Insurance",
        "Front Vehicle Image",
        "Rear Vehicle Image",
        "Right Side Image",
        "Left Side Image",
    ])

    const [imageKeysIndividual, setImageKeysIndividual] = useState([
        "Photo of the Owner",
        "Adhar Card Front",
        "Adhar Card Back",
        "Pan Card",
        "Cancelled cheque",
        "RC",
        "Insurance",
        "Front Vehicle Image",
        "Rear Vehicle Image",
        "Right Side Image",
        "Left Side Image",
        "GST",


        ...Array.from({ length: 0 }, (_, i) => `image${i + 1}`),
    ]);

    const [isSubmitting, setIsSubmitting] = useState(false);


    useEffect(() => {
        if (formData.vehicleNo?.length && typeOfAgreement == 'non-individual') {
            const initialState = {};
            formData.vehicleNo.forEach((v) => {
                initialState[v] = false;
            });
            setIsOpenImage(initialState);
        }
    }, [formData.vehicleNo, typeOfAgreement]);



    const loadStates = () => {
        setIsLoadingStates(true);
        fetch(`${config.cUrl}/states`, {
            headers: { "X-CSCAPI-KEY": config.ckey }
        })
            .then(response => response.json())
            .then(data => {
                setStates(data);
                setIsLoadingStates(false);
            })
            .catch(error => {
                console.error('Error loading states:', error);
                setIsLoadingStates(false);
            });
    }


    const loadCities = (stateCode) => {
        setIsLoadingCities(true);
        fetch(`${config.cUrl}/states/${stateCode}/cities`, {
            headers: { "X-CSCAPI-KEY": config.ckey }
        })
            .then(response => response.json())
            .then(data => {
                setCities(data);
                setIsLoadingCities(false);
            })
            .catch(error => {
                console.error('Error loading cities:', error);
                setIsLoadingCities(false);
            });
    };



    useEffect(() => {
        console.log('state?.mobileNo', state?.mobileNo)
        loadStates();
        if (state?.mobileNo) {
            setFormData(prev => ({
                ...prev,
                login_mobile: state?.mobileNo
            }))
        }
        const hasVisited = sessionStorage.getItem("hasVisitedModal");
        console.log('hasvis', typeof hasVisited, hasVisited)
        if (typeof hasVisited == null && state?.value !== 'additional-vehicles') {
            setIsModalOpen(true); // show modal on first visit
            sessionStorage.setItem("hasVisitedModal", true); // set flag so it won't show again
        }

    }, [state]);






    const handleInputChange = (e) => {
        const { name, value } = e.target;

        if (name === 'state') {
            loadCities(value);
        }

        if (name === "vendorPhone") {
            const digits = value.replace(/\D/g, "");

            // Prevent input beyond 10 digits
            if (digits.length > 10) return;

            setFormData((prev) => ({ ...prev, [name]: digits }));
            return;
        }

        setFormData((prev) => ({
            ...prev,
            [name]: value
        }));
    };


    const handleAddVehicleNo = () => {
        const newVehicle = tempVehicleNo.trim();
        if (newVehicle && !formData.vehicleNo.includes(newVehicle)) {
            setStoredVehicleNos([...storedVehicleNos, newVehicle]);
            setFormData((prevData) => ({ ...prevData, vehicleNo: [...(prevData.vehicleNo || []), newVehicle] }));
            setTempVehicleNo(""); // clear input
        }
    };

    const MAX_SIZE_MB = 1;
    const MAX_SIZE_BYTES = MAX_SIZE_MB * 1024 * 1024;

    const handleImageChange = async (key, file) => {
        if (!file) return;

        try {
            // const compressedFile = await compressFile(file);
            // console.log('compressedFile.size', compressedFile.size)
            // if (compressedFile.size > MAX_SIZE_BYTES) {
            //     alert('Image should be less than 1 MB.');
            //     return;
            // }

            setImages((prev) => ({
                ...prev,
                [key]: file,
            }));
        } catch (error) {
            console.error("Image compression error:", error);
            alert("Failed to process image.");
        }
    };


    const compressFile = (file) => {
        return new Promise((resolve, reject) => {
            // Allow image compression only for image types
            if (file.type.startsWith("image/")) {
                const reader = new FileReader();

                reader.onload = (event) => {
                    const img = new Image();
                    img.onload = () => {
                        const canvas = document.createElement("canvas");

                        const scale = Math.min(800 / img.width, 800 / img.height, 1);
                        canvas.width = img.width * scale;
                        canvas.height = img.height * scale;

                        const ctx = canvas.getContext("2d");
                        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

                        canvas.toBlob(
                            (blob) => {
                                if (blob) {
                                    const compressedFile = new File([blob], file.name, { type: file.type });
                                    if (compressedFile.size <= 1024 * 1024) {
                                        resolve(compressedFile);
                                    } else {
                                        reject(new Error("Image should be less than 1MB even after compression."));
                                    }
                                } else {
                                    reject(new Error("Compression failed"));
                                }
                            },
                            file.type,
                            0.7
                        );
                    };
                    img.onerror = reject;
                    img.src = event.target.result;
                };

                reader.onerror = reject;
                reader.readAsDataURL(file);
            } else {
                // For non-image files, check file size only
                if (file.size <= 1024 * 1024) {
                    resolve(file);
                } else {
                    reject(new Error("Document should be less than 1MB."));
                }
            }
        });
    };

    const [formErrors, setFormErrors] = useState({});
    const [isFormValid, setIsFormValid] = useState(false);
    const [openConfirmationModal, setOpenConfirmationModal] = useState(false);
    const [openConfirmationGoBackModal, setOpenConfirmationGoBackModal] = useState(false);



    const requiredFields = ["vehicleNo", "vendorName", "CompanyName", "fatherName", "vendorPhone", "state", "city", "address"];
    const [missingImages, setMissingImages] = useState([]);
    const [missingFieldsVehicles, setMissingFieldsVehicles] = useState({});
    const [userId, setUserId] = useState(localStorage.getItem('userId'))

    const handleAddVehicle = () => {
        const newKey = `temp-${Date.now()}`;
        setVehicleInputs([newKey]); // show only one input at a time
        setIsOpenImage({ [newKey]: true }); // open this new section
    };


    const handleVehicleInputChange = (key, value) => {
        setVehicleInputs([value]); // replace temp key with typed value

        // Only add if it’s not already in the list
        if (!formData.vehicleNo.includes(value)) {
            setFormData((prev) => ({
                ...prev,
                vehicleNo: [...prev.vehicleNo, value],
            }));

            // Open the section for this vehicle, close others
            setIsOpenImage({ [value]: true });
        }
    };

    const toggleVehicleImage = (vehicleNo) => {
        setIsOpenImage((prev) => ({
            ...Object.fromEntries(Object.keys(prev).map((k) => [k, false])),
            [vehicleNo]: !prev[vehicleNo],
        }));
    };

    useEffect(() => {
        const errors = {};
        for (const field of requiredFields) {
            if (typeOfAgreement === 'individual' && field === "companyName" || field === "CompanyName") {
                continue; // Skip validation for individuals
            }
            if (typeOfAgreement !== 'individual' && field === "vehicleNo") {
                continue; // Skip validation for individuals
            }
            if (!formData[field] || (Array.isArray(formData[field]) && formData[field].length === 0)) {
                errors[field] = true;
            }
        }

        if (formData.vendorPhone && formData.vendorPhone.length !== 10) {
            errors.vendorPhone = true;
        }
        setFormErrors(errors);
        setIsFormValid(Object.keys(errors).length === 0);
    }, [formData]);

    const handleContinue = (e) => {
        e.preventDefault();
        const nonRequiredPrefixes = ['image'];
        const requiredKeys = imageKeys.filter((key) => key !== "GST" && !nonRequiredPrefixes.some(pre => key.startsWith(pre)));
        const missing = requiredKeys.filter((key) => !images[key]);

        if (missing.length > 0) {
            console.log('sodd', missing)
            setMissingImages(missing);
            showError(`Please upload images for: ${missing.join(', ')}`);
            return; // Prevent navigation
        }

        // All required images are uploaded
        setMissingImages([]);
        setNextPage(3);
    };


    const handleAddImageField = () => {
        const newKey = `image${Object.keys(images).length + 1}`;
        setImageKeys((prev) => [...prev, newKey]);
    };

    const handleAddVehicleImageField = () => {
        const newKey = `image${Object.keys(images).length + 1}`;
        setImageKeysForVehicle((prev) => [...prev, newKey]);
    }

    const handleAddImageCompanyField = () => {
        const newKey = `image${Object.keys(images).length + 1}`;
        setImageKeysIndividual((prev) => [...prev, newKey]);
    };

    const showSuccessToast = (e) => {
        toast.success(e);
    };




    const handleContinue2 = (e) => {
        e.preventDefault();
        const requiredKeys = imageKeysIndividual.filter((key) => key !== "GST");
        const missing = requiredKeys.filter((key) => !images[key]);

        if (missing.length > 0) {
            setMissingImages(missing);
            return; // Prevent navigation
        }

        // All required images are uploaded
        setMissingImages([]);

        const isValid = validationCheckFunction();
        if (!isValid) {
            setOpenValidationModal(true);
            return;
        }

        setOpenConfirmationModal(true);
    }

    const [countOfImages, setCountOfImages] = useState(0);
    const [openDeletionModal, setOpenDeletionModal] = useState(false);
    const [wantToGoBack, setWantToGoBack] = useState(false);
    const [deletionVehicle, setDeletionVehicle] = useState(null);

    const deleteVehicleOld = async (choosenVehicleNo) => {
        console.log('choosenVehicleNo', choosenVehicleNo);
        console.log('images123', images);
        console.log("images[`RC-${choosenVehicleNo}`]", images[`RC-${choosenVehicleNo}`]);
        console.log('formData1234', formData);

        // Keys to check and delete from images
        const imageKeys = [
            `RC-${choosenVehicleNo}`,
            `Insurance-${choosenVehicleNo}`,
            `Front Vehicle Image-${choosenVehicleNo}`,
            `Rear Vehicle Image-${choosenVehicleNo}`,
            `Left Side Image-${choosenVehicleNo}`,
            `Right Side Image-${choosenVehicleNo}`
        ];

        let deletedImageCount = 0;

        imageKeys.forEach((key) => {
            if (images[key] !== undefined) {
                delete images[key];
                deletedImageCount++;
            }
        });

        // Remove driver info from formData
        const detailKeys = [
            `driverName-${choosenVehicleNo}`,
            `driverNumber-${choosenVehicleNo}`,
            `driverDLNo-${choosenVehicleNo}`
        ];

        detailKeys.forEach((key) => {
            if (formData[key] !== undefined) {
                delete formData[key];
            }
        });

        // Remove vehicleNo from the array
        const updatedVehicleNo = formData.vehicleNo.filter(
            (vNo) => vNo !== choosenVehicleNo
        );

        // Update state
        setFormData((prev) => ({
            ...prev,
            vehicleNo: updatedVehicleNo,
        }));

        // Reset input and update count once
        setInputValue('');
        setCountOfImages(deletedImageCount); // Set once, based on what was actually deleted

        console.log('deletedImageCount', deletedImageCount);
        console.log("Updated images:", images);
        console.log("Updated formData:", formData);
        console.log('countofimages', countOfImages)

        if (deletedImageCount === 0) {
            if (wantToGoBack) navigate('/AllAddedVehiclesNew')
            // return;
        } // Skip backend call if nothing was deleted


        try {
            const res = await axios.delete(
                `${process.env.REACT_APP_BACKEND_URL}/api/deleteVehicleInfo/${userId}/${choosenVehicleNo}`,
                {
                    headers: { "Content-Type": "application/json" },
                }
            );
            if (res.status === 200) {
                setIsSubmitting(false);
                if (wantToGoBack) navigate('/AllAddedVehiclesNew')
                setCountOfImages(0);
            }
        } catch (error) {
            console.error("Image compression error:", error);
            alert("Failed to process image.");
        }
    };

    const deleteVehicle = async (choosenVehicleNo) => {
        const imageKeys = [
            `RC-${choosenVehicleNo}`,
            `Insurance-${choosenVehicleNo}`,
            `Front Vehicle Image-${choosenVehicleNo}`,
            `Rear Vehicle Image-${choosenVehicleNo}`,
            `Left Side Image-${choosenVehicleNo}`,
            `Right Side Image-${choosenVehicleNo}`,
            `Driver DL-${choosenVehicleNo}`
        ];

        const detailKeys = [
            `driverName-${choosenVehicleNo}`,
            `driverNumber-${choosenVehicleNo}`,
            `driverDLNo-${choosenVehicleNo}`,
            `driverDOB-${choosenVehicleNo}`
        ];

        // 🔁 Count how many images exist before deletion
        const currentImages = { ...images };
        const deletedCount = imageKeys.reduce((count, key) => {
            return currentImages[key] ? count + 1 : count;
        }, 0);

        console.log('Deleted image count before update:', deletedCount);

        // 🖼️ Remove images for the chosen vehicle
        setImages((prev) => {
            const updated = { ...prev };
            imageKeys.forEach((key) => delete updated[key]);
            return updated;
        });

        // 🚗 Remove only chosen vehicle's driver details
        setFormData((prev) => {
            const updated = { ...prev };

            detailKeys.forEach((key) => delete updated[key]);

            // Update vehicleNo list to remove the chosen vehicle
            updated.vehicleNo = (prev.vehicleNo || []).filter(
                (vNo) => vNo && vNo !== choosenVehicleNo
            );

            return updated;
        });

        // Reset UI-related state
        setInputValue('');
        setCountOfImages(deletedCount);

        // If no images were deleted, skip backend call
        if (deletedCount === 0) return;

        // 🧾 Backend DELETE request
        try {
            const res = await axios.delete(
                `${process.env.REACT_APP_BACKEND_URL}/api/deleteVehicleInfo/${userId}/${choosenVehicleNo}`,
                {
                    headers: { "Content-Type": "application/json" },
                }
            );

            if (res.status === 200) {
                setIsSubmitting(false);
                setCountOfImages(0);
                // navigate("/AllAddedVehiclesNew")

                if (formData.vehicleNo.length === 0) {
                    navigate("/AllAddedVehiclesNew")
                }
            }
        } catch (error) {
            console.error("Error deleting vehicle data:", error);
            alert("Failed to delete vehicle.");
        }
    };

    const readyToSubmit = (e) => {
        e.preventDefault();
        if (typeOfAgreement !== 'individual') {
            const isValid = validationCheckFunction();
            if (!isValid) {
                setOpenValidationModal(true);
                return;
            }
        }

        setOpenConfirmationModal(true);
    }

    const handleImageChangeForVehicle = async (key, file) => {
        if (!file) return;
        setIsSubmitting(true);

        console.log('key1232', key)
        const keyStr = key[0]; // 'RC-HR93TS3823'
        const currentVehicleNo = keyStr.split("-")[1]; // 'HR93TS3823'

        const driverName = formData[`driverName-${currentVehicleNo}`];
        const driverNumber = formData[`driverNumber-${currentVehicleNo}`];
        const driverDLNo = formData[`driverDLNo-${currentVehicleNo}`];

        console.log("driverdlno1234", { currentVehicleNo, driverName, driverNumber, driverDLNo });

        const vehicleDetails = new FormData();
        vehicleDetails.append(key[0], file);
        vehicleDetails.append("vehicleNo", currentVehicleNo);
        vehicleDetails.append("driverName", driverName);
        vehicleDetails.append("driverNumber", driverNumber);
        vehicleDetails.append("driverDLNo", driverDLNo);
        vehicleDetails.append("vendorPhone", localStorage.getItem("vendorPhone"));

        for (let pair of vehicleDetails.entries()) {
            console.log(`${pair[0]}:`, pair[1]);
        }

        // You can now submit `vehicleDetails` to the backend



        try {
            const res = await axios.put(
                `${process.env.REACT_APP_BACKEND_URL}/api/submit-driver-details/${userId}`,
                vehicleDetails,
                {
                    headers: { "Content-Type": "multipart/form-data" },
                }
            );
            // if (res.status === 201) {
            if (res.data.status === true) {
                console.log("✅ Image uploaded");
                setImages((prev) => ({ ...prev, [key[0]]: file }));
                setIsSubmitting(false);
            }

            // }
        } catch (error) {
            console.error("Image compression error:", error);          
            openModal({
                title: 'Error',
                body: "Mobile No. is already available!",
                iconType: 'error',
                autoClose: true,
            });
        }
        finally {
            setIsSubmitting(false);
        }
        }



    const validationCheckFunction = () => {
        let newMissingFields = {};
        let firstIncompleteVehicle = null;

        if (typeOfAgreement !== 'individual') {
            if (formData.vehicleNo.length == 0) {
                setIsSubmitting(false);
                return;
            }
            formData.vehicleNo.forEach((vehicleNo) => {
                const driverNameKey = `driverName-${vehicleNo}`;
                const driverNumberKey = `driverNumber-${vehicleNo}`;
                console.log('drivername', driverNameKey)
                console.log('drivername', driverNumberKey)

                const missing = [];

                if (!formData[driverNameKey]) missing.push(driverNameKey);
                if (!formData[driverNumberKey]) missing.push(driverNumberKey);

                console.log('fomrad', formData[driverNameKey])
                console.log('fomrad', formData[driverNumberKey])

                imageKeysForVehicle.forEach((key) => {
                    const imageKey = `${key}-${vehicleNo}`;
                    if (!images[imageKey]) missing.push(imageKey);
                });

                if (missing.length > 0) {
                    newMissingFields[vehicleNo] = missing;
                    if (!firstIncompleteVehicle) firstIncompleteVehicle = vehicleNo;
                }
            });

            if (Object.keys(newMissingFields).length > 0) {
                setMissingFieldsVehicles(newMissingFields);
                if (firstIncompleteVehicle) {
                    setIsOpenImage({ [firstIncompleteVehicle]: true });
                    document.getElementById(`vehicle-section-${firstIncompleteVehicle}`)?.scrollIntoView({ behavior: 'smooth' });
                }
                setIsSubmitting(false); // Start loader

                return false; // Don't submit
            }

            // ✅ All valid
            setMissingFieldsVehicles({});
        }
        return true;
    }
    const handleSubmit = async (e) => {
        // if (e?.preventDefault) e.preventDefault();
        // if (typeOfAgreement !== 'individual') e.preventDefault();
        setIsSubmitting(true); // Start loader

        let newMissingFields = {};
        let firstIncompleteVehicle = null;


        if (formData.vehicleNo.length == 0) {
            setIsSubmitting(false);
            return;
        }
        formData.vehicleNo.forEach((vehicleNo) => {
            const driverNameKey = `driverName-${vehicleNo}`;
            const driverNumberKey = `driverNumber-${vehicleNo}`;
            console.log('drivername', driverNameKey)
            console.log('drivername', driverNumberKey)

            const missing = [];

            if (!formData[driverNameKey]) missing.push(driverNameKey);
            if (!formData[driverNumberKey]) missing.push(driverNumberKey);

            console.log('fomrad', formData[driverNameKey])
            console.log('fomrad', formData[driverNumberKey])

            imageKeysForVehicle.forEach((key) => {
                const imageKey = `${key}-${vehicleNo}`;
                if (!images[imageKey]) missing.push(imageKey);
            });

            if (missing.length > 0) {
                newMissingFields[vehicleNo] = missing;
                if (!firstIncompleteVehicle) firstIncompleteVehicle = vehicleNo;
            }
        });

        if (Object.keys(newMissingFields).length > 0) {
            setMissingFieldsVehicles(newMissingFields);
            if (firstIncompleteVehicle) {
                setIsOpenImage({ [firstIncompleteVehicle]: true });
                document.getElementById(`vehicle-section-${firstIncompleteVehicle}`)?.scrollIntoView({ behavior: 'smooth' });
            }
            setIsSubmitting(false); // Start loader

            return; // Don't submit
        }

        // ✅ All valid
        setMissingFieldsVehicles({});

        const formDataObj = new FormData();

        // Append all text fields
        for (const key in formData) {
            if (formData[key] !== undefined && formData[key] !== null && formData[key] !== "") {
                if (key === "rate" || key === "perHR") {
                    formDataObj.append(key, formData[key] === "" ? "0" : formData[key]);
                } else {
                    formDataObj.append(key, formData[key]);
                }
            }
        }
        formDataObj.append('typeOfAgreement', typeOfAgreement)
        // Append all image files
        for (const key in images) {
            const file = images[key];
            if (file instanceof File) {
                formDataObj.append(`images[${key}]`, file, file.name);
            }
        }

        console.log('_____________________________________________________________________')
        for (let pair of formDataObj.entries()) {
            console.log(`${pair[0]}:`, pair[1]);
        }

        // return

        try {
            const res = await axios.put(
                `${process.env.REACT_APP_BACKEND_URL}/api/newVehicleAddedByVendor/${userId}`,
                formDataObj,
                {
                    headers: { "Content-Type": "multipart/form-data" },
                }
            );

            if (res.data?.message === "Vehicle info stored successfully") {
                console.log("✅ Submitted:", res.data);
                // setAlertInfo({ show: true, message: "Form Details filled successfully !!!", severity: 'success' });
                setIsSubmitting(false); // Stop loader
                showSuccessToast('Form Details filled successfully !!!')
                setTimeout(() => {
                    navigate('/AllAddedVehiclesNew');
                }, 3000)

            }
            else {
                // setAlertInfo({ show: true, message: "File size should be less than 2 MB!", severity: 'error' });
                console.log("❌ Submission failed:", res.data.message);
                setIsSubmitting(false)
                showSuccessToast(res.data.message)
            }
        } catch (err) {
            console.error("❌ Submit error:", err);
            setAlertInfo({ show: true, message: err.response.data.message, severity: 'error' });

            setIsSubmitting(false); // Stop loader on error too
        }
    };

    const canAddNewVehicle = () => {
        const lastVehicle = formData.vehicleNo[formData.vehicleNo.length - 1];
        if (!lastVehicle) return true;

        const driverNameKey = `driverName-${lastVehicle}`;
        const driverNumberKey = `driverNumber-${lastVehicle}`;

        if (!formData[driverNameKey] || !formData[driverNumberKey]) return false;

        for (let key of imageKeysForVehicle) {
            const combinedKey = `${key}-${lastVehicle}`;
            if (!images[combinedKey]) return false;
        }
        return true;
    };

    const canGoBack = () => {
        const lastVehicle = formData.vehicleNo[formData.vehicleNo.length - 1];
        console.log('lastvehicle', lastVehicle)
        if (!lastVehicle) {
            console.log('uou can navigate')
            navigate('/AllAddedVehiclesNew');
        }

        const driverNameKey = `driverName-${lastVehicle}`;
        const driverNumberKey = `driverNumber-${lastVehicle}`;

        if (!formData[driverNameKey] || !formData[driverNumberKey]) {
            setDeletionVehicle(lastVehicle)
            setOpenDeletionModal(true)
            setWantToGoBack(true)
            return false;
        };

        for (let key of imageKeysForVehicle) {
            const combinedKey = `${key}-${lastVehicle}`;
            if (!images[combinedKey]) {
                setDeletionVehicle(lastVehicle)
                setOpenDeletionModal(true)
                setWantToGoBack(true)
                return false;

            }
        }
        setOpenConfirmationGoBackModal(true);
    };

    const [popupMessage, setPopupMessage] = useState('');
    const [showPopup, setShowPopup] = useState(false);

    const showError = (message) => {
        setPopupMessage(message);
        setShowPopup(true);
        setTimeout(() => setShowPopup(false), 3000);
    };

    const [isLoading, setIsLoading] = useState(false);
    const { openModal, modalData, closeModal } = useModal();
    const [showDetails, setShowDetails] = useState(false);
    const [formAdditionalData, setFormAdditionalData] = useState(null)
    const showDetailsRef = useRef(null)

    const response = {
        success: true,
        data: {
            "Vehicle_stautsMessage": "OK",
            "Vehicle_rc_regn_no": "HR46E8144",
            "Vehicle_rc_regn_dt": "08-Oct-2018",
            "Vehicle_rc_regn_upto": "15-Jul-2022",
            "Vehicle_rc_purchase_dt": "16-Apr-2018",
            "Vehicle_rc_owner_sr": "1",
            "Vehicle_rc_owner_name": "S*R K*R",
            "Vehicle_state_cd": "HR",
            "Vehicle_rto_cd": "46",
            "Vehicle_api_response_message": "No response received from AITP API.",
            "Vehicle_rc_present_address": "Rohtak, 124001",
            "Vehicle_rc_permanent_address": "Rohtak, 124001",
            "Vehicle_rc_vch_catg": "LGV",
            "Vehicle_rc_vh_class_desc": "Goods Carrier(LGV)",
            "Vehicle_rc_chasi_no": "MAT505410H0K*",
            "Vehicle_rc_eng_no": "3.8SGI72KSY8*",
            "Vehicle_rc_maker_desc": "TATA MOTORS LTD",
            "Vehicle_rc_maker_model": "TATA SFC 407 CNG / 31 BS-IV",
            "Vehicle_rc_body_type_desc": "RECOVERY VAN",
            "Vehicle_rc_fuel_desc": "CNG ONLY",
            "Vehicle_rc_color": "NA",
            "Vehicle_rc_norms_desc": "BHARAT STAGE IV",
            "Vehicle_rc_fit_upto": "15-Jul-2022",
            "Vehicle_rc_np_upto": "07-Oct-2020",
            "Vehicle_rc_np_issued_by": "Secretary, RTA Rohtak",
            "Vehicle_rc_tax_upto": "31-08-2022",
            "Vehicle_rc_financer": "INDIA INFOLINE FINANCE LTD",
            "Vehicle_rc_insurance_comp": "National Insurance Co. Ltd.",
            "Vehicle_rc_insurance_policy_no": "42060031216360002229",
            "Vehicle_rc_insurance_upto": "04-Jan-2023",
            "Vehicle_rc_manu_month_yr": "10/2017",
            "Vehicle_rc_unld_wt": "2430",
            "Vehicle_rc_gvw": "5550",
            "Vehicle_rc_no_cyl": "4",
            "Vehicle_rc_cubic_cap": "3783.00",
            "Vehicle_rc_seat_cap": "3",
            "Vehicle_rc_sleeper_cap": "0",
            "Vehicle_rc_stand_cap": "0",
            "Vehicle_rc_wheelbase": "3100",
            "Vehicle_rc_registered_at": "RTA, ROHTAK, Haryana",
            "Vehicle_rc_status_as_on": "06-May-2025",
            "Vehicle_rc_pucc_upto": "19-Aug-2022",
            "Vehicle_rc_pucc_no": "HR04600220002561",
            "Vehicle_rc_status": "Fitness Expired",
            "Vehicle_rc_ncrb_status": null,
            "Vehicle_rc_blacklist_status": null,
            "Vehicle_rc_permit_no": "HR/46/NP/LGV/2018/28",
            "Vehicle_rc_permit_issue_dt": "08-Oct-2018",
            "Vehicle_rc_permit_valid_from": "08-Oct-2018",
            "Vehicle_rc_permit_valid_upto": "07-Oct-2023",
            "Vehicle_rc_permit_type": "National Permit [LIGHT GOODS VEHICLE]",
            "Vehicle_rc_permit_code": "106",
            "Vehicle_rc_noc_details": null,
            "Vehicle_rc_vh_type": "T",
            "Vehicle_rc_vh_class": "59",
            "Vehicle_rc_noc_dt": null,
            "Vehicle_rc_fuel_cd": "6",
            "Vehicle_rc_maker_cd": "86",
            "Vehicle_rc_model_cd": "55320831000R",
            "Vehicle_rc_norms_cd": "0",
            "Vehicle_rc_sale_amt": "1020823.0",
            "Vehicle_rc_own_catg_desc": "OTHERS",
            "Vehicle_rc_vch_catg_desc": "LIGHT GOODS VEHICLE",
            "Vehicle_rc_owner_cd_desc": "INDIVIDUAL",
            "Vehicle_rc_vehicle_surrendered_to_dealer": "0",
            "Vehicle_rc_owner_history_offName": null,
            "Vehicle_rc_owner_history_owner_name": null,
            "Vehicle_rc_owner_history_owner_sr": "0",
            "Vehicle_rc_owner_history_stateCd": null,
            "Vehicle_rc_currentadd_districtcode": "0",
            "Vehicle_rc_non_use": "false",
            "Vehicle_rc_passenger_tax": null,
            "Vehicle_rc_goods_tax": null,
            "Vehicle_rc_no_of_axle": "2",
            "Vehicle_rc_qr_url": null,
            "Vehicle_rc_auth_name": null,
            "Vehicle_rc_auth_sign": null,
            "Vehicle_rc_approval_date": null,
            "Vehicle_rc_hp": null,
            "Vehicle_rc_mandal_desc": null,
            "Vehicle_rc_taluk_cd": null,
            "Vehicle_rc_permit_catg": "105",
            "Vehicle_rc_tax_mode": "M",
            "Vehicle_rc_permit_issuing_authority": "RTA, ROHTAK",
            "Vehicle_rc_width": null,
            "Vehicle_rc_fitness_result": null
        }
    };


    const verifyRC = async () => {
        // return
        console.log('Fetching vehicle details: ')

        try {

            // { vh_number: "HR46E8144" },

            setIsLoading(false)

            // const response = await axios.post(
            //     "https://dashboard.traqo.in/api/v1/kyc/verify_rc/",
            //     { vh_number: inputValue },
            //     {
            //         auth: {
            //             username: "9312408268",
            //             password: "9312408268@123",
            //         },
            //         headers: {
            //             "Content-Type": "application/json"
            //         }
            //     }
            // );

            console.log("Response:", response.data);

            if (response?.data && response?.data?.data?.Vehicle_msg === "No data found") {

                openModal({
                    title: 'Error',
                    body: 'No vehicle data found',
                    iconType: 'error',
                    autoClose: true,
                });
                return;
            }

            // Enable below line when calling above API
            // if (response?.data && response?.data?.data?.Vehicle_stautsMessage === 'OK') {
            if (response?.data) {
                console.log("RC Verified:", response.data.data);

                // setVehicleDetails((prev) => ({
                //     ...prev,
                //     vehicleNo: [...prev.vehicleNo, inputValue],
                // }));

                setFormData((prevState) => ({
                    ...prevState,
                    engineNo: response.data.Vehicle_rc_eng_no,
                    chassisNo: response.data.Vehicle_rc_chasi_no,
                    make: response.data.Vehicle_rc_maker_desc,
                    model: response.data.Vehicle_rc_maker_model,
                    year: response.data.Vehicle_rc_manu_month_yr?.split('/')[1],
                    GVW: response.data.Vehicle_rc_gvw,
                    InsuranceName: response.data.Vehicle_rc_insurance_comp,
                    InsuranceValidUpto: response.data.Vehicle_rc_insurance_upto,
                    ownerName: response.data.Vehicle_rc_owner_name,
                    ownerAddress: response.data.Vehicle_rc_present_address,
                    state: response.data.Vehicle_state_cd,
                    city: response.data.Vehicle_rc_present_address?.split(',')[0].trim(),
                    pincode: response.data.Vehicle_rc_present_address?.split(',')[1]?.trim(),
                    vehicleNo: [...prevState.vehicleNo, inputValue],

                }));

                setShowVehicleInput(false)

                // setFormAdditionalData({
                //     Vehicle_rc_body_type_desc: response.data.Vehicle_rc_body_type_desc,
                //     Vehicle_rc_regn_no: response.data.Vehicle_rc_regn_no,
                //     Vehicle_rc_owner_name: response.data.Vehicle_rc_owner_name,
                //     Vehicle_rc_permanent_address: response.data.Vehicle_rc_permanent_address,
                //     Vehicle_rc_chasi_no: response.data.Vehicle_rc_chasi_no,
                //     Vehicle_rc_eng_no: response.data.Vehicle_rc_eng_no,
                //     Vehicle_rc_maker_desc: response.data.Vehicle_rc_maker_desc,
                //     Vehicle_rc_maker_model: response.data.Vehicle_rc_maker_model,
                //     Vehicle_rc_fit_upto: response.data.Vehicle_rc_fit_upto,
                //     Vehicle_rc_tax_upto: response.data.Vehicle_rc_tax_upto,
                //     Vehicle_rc_financer: response.data.Vehicle_rc_financer,
                //     Vehicle_rc_insurance_comp: response.data.Vehicle_rc_insurance_comp,
                //     Vehicle_rc_insurance_policy_no: response.data.Vehicle_rc_insurance_policy_no,
                //     Vehicle_rc_insurance_upto: response.data.Vehicle_rc_insurance_upto,
                //     Vehicle_rc_unld_wt: response.data.Vehicle_rc_unld_wt,
                //     Vehicle_rc_gvw: response.data.Vehicle_rc_gvw,
                //     Vehicle_rc_pucc_upto: response.data.Vehicle_rc_pucc_upto,
                //     Vehicle_rc_pucc_no: response.data.Vehicle_rc_pucc_no,
                //     Vehicle_rc_status: response.data.Vehicle_rc_status,
                //     Vehicle_rc_permit_no: response.data.Vehicle_rc_permit_no,
                //     Vehicle_rc_permit_issue_dt: response.data.Vehicle_rc_permit_issue_dt,
                //     Vehicle_rc_permit_valid_upto: response.data.Vehicle_rc_permit_valid_upto,
                // })

                // loadCities(response.data.Vehicle_state_cd);

                // arrowRef.current?.click();

                setShowDetails(true)

                setIsOpenImage((prev) => ({
                    ...Object.fromEntries(Object.keys(prev).map((k) => [k, false])), // Close all
                    [inputValue]: true, // Open the new one
                }));

            } else {
                console.warn("Verification failed or returned false");
            }


        } catch (error) {
            console.error("Error:", error?.response?.data || error?.message);
            console.log(error?.response?.data?.status)

            if (error?.response?.data?.status) {
                openModal({
                    title: 'Error',
                    body: error?.response?.data?.status,
                    iconType: 'error',
                    autoClose: true,
                });
            }
            // clearForm();
            // setFormAdditionalData({});

        }
        finally {
            setIsLoading(false)
        }
    };

    return (
        <div className="bg-white h-[100vh]">

            <div className="flex md:flex-row flex-col justify-center gap-[30px]">
                <div>
                    <div className="hidden flex items-end justify-end pt-3">
                        <div
                            className={`flex items-center py-[5px] rounded-full pr-[6px] pl-[16px] cursor-pointer bg-[#21A6E9] hover:bg-red-300`}
                        >
                            <button className="flex items-center gap-2 font-satoshi font-[400] text-[18px] leading-[33.6px] text-white pr-5">
                                <img
                                    src="https://static.vecteezy.com/system/resources/previews/019/879/209/non_2x/download-button-on-transparent-background-free-png.png"
                                    alt="icon"
                                    className="h-[40px] w-[40px] object-contain"
                                />
                                Generate Excel
                            </button>
                        </div>
                    </div>

                    <div className=" flex items-center justify-center gap-4 pt-1 ">

                    </div>

                    {/* {typeOfAgreement === "non-individual" && ( */}
                    <div>
                        {isLoading && (
                            <div className="fixed inset-0 z-[9999] bg-gray-100 bg-opacity-80 flex items-center justify-center">
                                <div className="loader2 h-[50px] w-[20px]"></div>
                            </div>
                        )}
                        <div className="flex justify-end mt-2 mr-2">

                            {state?.value !== 'additional-vehicles' && (
                                <svg hidden
                                    xmlns="http://www.w3.org/2000/svg"
                                    onClick={() => setIsModalOpen(!isModalOpen)}
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="lucide lucide-text-select cursor-pointer"
                                >
                                    <path d="M14 21h1" /><path d="M14 3h1" />
                                    <path d="M19 3a2 2 0 0 1 2 2" /><path d="M21 14v1" />
                                    <path d="M21 19a2 2 0 0 1-2 2" /><path d="M21 9v1" />
                                    <path d="M3 14v1" /><path d="M3 9v1" />
                                    <path d="M5 21a2 2 0 0 1-2-2" /><path d="M5 3a2 2 0 0 0-2 2" />
                                    <path d="M7 12h10" /><path d="M7 16h6" /><path d="M7 8h8" />
                                    <path d="M9 21h1" /><path d="M9 3h1" />
                                </svg>)}
                        </div>
                        {state?.value !== 'additional-vehicles' && (<div>
                            {nextPage === 1 && (
                                <form className=" font-satoshi max-w-xl mx-auto p-[1.5rem] bg-white rounded-md space-y-4 mb-5 ">


                                    <div className="flex  md:flex-row items-center gap-2 p-2">
                                        <img src="https://cdn.pixabay.com/photo/2020/07/01/12/58/icon-5359553_640.png" className="h-[40px] w-[40px] mt-1" alt="" />
                                        <h2 className="text-sm font-semibold text-center my-2">COMPANY INFORMATION</h2>

                                    </div>
                                    {["vendorName", "CompanyName", "fatherName", "vendorPhone", "state", "city", "address"].map((field) => (
                                        <div key={field} className="flex flex-col">
                                            <label
                                                htmlFor={field}
                                                className="mb-1 text-sm font-medium text-gray-700 capitalize font-semibold text-[12px]"
                                            >
                                                {field.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase())}
                                                <span className="text-red-500 contents"> *</span>
                                            </label>



                                            {/* Handle textarea for residence_address */}
                                            {field === "address" ? (
                                                <textarea
                                                    id={field}
                                                    name={field}
                                                    value={formData.address || ""}
                                                    placeholder={`Enter ${field.replace(/_/g, " ")}`}
                                                    onChange={handleInputChange}
                                                    className={`border ${formErrors[field] ? "border-red-500" : "border-[#DEDEE8]"} bg-[#F6F6F6] rounded-[7px] pl-[15px] py-[16px] px-[10px] w-full`}

                                                    rows={4}
                                                />
                                            ) : field === "state" ? (
                                                // Handle state dropdown
                                                <select
                                                    id={field}
                                                    name={field}
                                                    value={formData.state || ""}
                                                    onChange={handleInputChange}
                                                    disabled={isLoadingStates}
                                                    className="font-satoshi border border-[#DEDEE8] bg-[#F6F6F6] rounded-[7px] pl-[15px] py-[16px] px-[10px] w-full"

                                                >
                                                    <option value="">Select State</option>
                                                    {states.map(state => (
                                                        <option key={state.iso2} value={state.iso2}>{state.name}</option>
                                                    ))}
                                                </select>
                                            ) : field === "city" ? (
                                                // Handle city dropdown
                                                <select
                                                    id={field}
                                                    name={field}
                                                    value={formData.city || ""}
                                                    onChange={handleInputChange}
                                                    disabled={isLoadingCities || !formData.state}
                                                    // className="border border-[#DEDEE8] bg-[#F6F6F6] rounded-[7px] pl-[15px] py-[16px] px-[10px] w-full"
                                                    className="font-satoshi border border-[#DEDEE8] bg-[#F6F6F6] rounded-[7px] pl-[15px] py-[16px] px-[10px] w-full"

                                                >
                                                    <option value="">Select City</option>
                                                    {!cities.error && cities.map(city => (
                                                        <option key={city.name} value={city.name}>
                                                            {city.name}
                                                        </option>


                                                    ))}
                                                </select>
                                            ) : field === "vehicleNo" ? (
                                                <div className="flex flex-col gap-2">
                                                    <div className="flex gap-2">
                                                        <input
                                                            id={field}
                                                            name={field}
                                                            value={tempVehicleNo}
                                                            placeholder={`Enter ${field.replace(/_/g, " ")}`}
                                                            onChange={(e) => setTempVehicleNo(e.target.value.toUpperCase())}
                                                            className="font-satoshi border border-[#DEDEE8] bg-[#F6F6F6] rounded-[7px] pl-[15px] py-[16px] px-[10px] w-full"
                                                        />
                                                        <div
                                                            style={{ background: '#21A6E9' }}
                                                            className="relative center-button text-white p-2 rounded-full shadow-lg hover:bg-black focus:outline-none mt-2 h-[40px] cursor-pointer"
                                                            onClick={handleAddVehicleNo}
                                                        >
                                                            <AddIcon />
                                                        </div>
                                                    </div>

                                                    {/* Display all stored vehicle numbers */}
                                                    {formData.vehicleNo.map((vehicleNo, index) => (
                                                        <div
                                                            key={index}
                                                            style={{ background: 'rgb(226 248 255)', border: '1px solid' }}
                                                            className="relative flex text-black max-w-[45vw] rounded-full px-4 py-2 mb-2 sm:text-[12px] md:text-[15px]"

                                                        >
                                                            {vehicleNo}
                                                            <button
                                                                type="button"
                                                                onClick={() => {
                                                                    const updatedVehicleNos = [...formData.vehicleNo];
                                                                    updatedVehicleNos.splice(index, 1);
                                                                    setFormData((prev) => ({
                                                                        ...prev,
                                                                        vehicleNo: updatedVehicleNos,
                                                                    }));
                                                                }}
                                                                className="absolute top-1 right-2 text-red-600 font-bold hover:text-red-800"
                                                                title="Remove"
                                                            >
                                                                ✕
                                                            </button>
                                                        </div>
                                                    ))}

                                                </div>
                                            ) : (
                                                // Handle regular input
                                                <input
                                                    id={field}
                                                    name={field}
                                                    placeholder={`Enter ${field.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase())}`}
                                                    value={formData[field] || ""}
                                                    onChange={(e) => {
                                                        let value = e.target.value;

                                                        // Capitalize owner_name and father_name
                                                        if (["vendorName", "fatherName"].includes(field)) {
                                                            value = value.toUpperCase();
                                                        }

                                                        // Restrict mobile_no to 10 digits only
                                                        if (field === "vendorPhone") {
                                                            value = value.replace(/\D/g, "").slice(0, 10);
                                                        }

                                                        handleInputChange({ target: { name: field, value } });
                                                    }}
                                                    className="border border-[#DEDEE8] bg-[#F6F6F6] rounded-[7px] pl-[15px] py-[16px] px-[10px] w-full"
                                                    style={{ padding: "20px" }}
                                                />
                                            )}
                                        </div>
                                    ))}



                                    <div className="flex justify-center fixed bottom-0 left-0 right-0 z-[10] md:relative md:bottom-auto md:left-auto md:right-auto">
                                        <div className="mobile-only-shadow flex items-center justify-between bg-white p-2 rounded-t-xl w-full max-w-[30rem] gap-[0.5rem] mx-auto md:rounded-none md:p-0 md:bg-transparent">

                                            <button
                                                onClick={() => setNextPage(2)}
                                                disabled={!isFormValid}
                                                className={`flex items-center justify-center gap-2 text-white text-base font-medium py-3 px-2 rounded-full transition-all w-full
                                            ${isFormValid ? "bg-[#21A6E9] hover:bg-[#1e94d6]" : "bg-gray-400 cursor-not-allowed"}`}
                                            >
                                                Continue
                                                <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/navbar/right-arrow.svg' alt="Next" className="h-[24px] w-[24px]" />
                                            </button>


                                            <div className="flex-grow max-w-[5rem] min-w-[1rem]"></div>

                                        </div>
                                    </div>




                                </form>
                            )}

                            {nextPage === 2 && (
                                <form className=" font-satoshi max-w-xl mx-auto p-[1.5rem] bg-white rounded-md space-y-4 mb-5 ">
                                    <div className="flex  md:flex-row items-center justify-between gap-2 p-2">
                                        <h2 className="text-xl font-semibold text-center my-2">UPLOAD IMAGES</h2>

                                    </div>

                                    <div className="overflow-auto grid grid-cols-2 lg:grid-cols-2 gap-[0.7rem]">
                                        {imageKeys.map((key) => (
                                            <div key={key} style={{ border: '2px dotted gray', ...(missingImages.includes(key) && { border: '2px dotted red' }) }} className="flex flex-col relative p-[0.2rem] rounded-md rounded-xl ">
                                                {images[key] ? (
                                                    <div className="relative w-full h-[6rem] mb-2 rounded-[10%] ">
                                                        <img
                                                            src={URL.createObjectURL(images[key])}
                                                            alt={key}
                                                            className="w-full h-[9rem] rounded-xl object-cover"
                                                        />
                                                        <button
                                                            type="button"
                                                            onClick={() =>
                                                                setImages((prev) => {
                                                                    const newImages = { ...prev };
                                                                    delete newImages[key];
                                                                    return newImages;
                                                                })
                                                            }
                                                            className="absolute top-0 right-0 bg-red-200 text-white rounded-full w-6 h-6 flex items-center justify-center text-xs hover:bg-red-600"
                                                            title="Remove Image"
                                                        >
                                                            ❌
                                                        </button>
                                                    </div>

                                                ) : (
                                                    <div className="flex flex-col items-center justify-center mt-[2rem]">
                                                        <button
                                                            type="button"
                                                            style={{ background: 'rgb(140 140 140)' }}
                                                            className="relative center-button text-white p-2 rounded-full shadow-lg hover:bg-black focus:outline-none"
                                                            onClick={() => document.getElementById(`hiddenFileInput-${key}`).click()}
                                                        >
                                                            <AddIcon />
                                                        </button>
                                                        <input
                                                            type="file"
                                                            id={`hiddenFileInput-${key}`}
                                                            accept="image/*"
                                                            onChange={(e) => handleImageChange(key, e.target.files[0])}
                                                            className=" form-control text-xs hidden opacity-0"
                                                        />
                                                    </div>

                                                )}
                                                <label className="mb-1 text-sm font-medium font-semibold text-[12px] text-gray-700 mt-[1rem] text-center">
                                                    {key.charAt(0).toUpperCase() + key.slice(1)}
                                                </label>
                                            </div>
                                        ))}
                                    </div>

                                    {Object.keys(images).length >= 6 && (
                                        <div className="flex justify-end  mb-4 px-2 py-1">
                                            <button
                                                type="button"
                                                onClick={handleAddImageField}
                                                className="border-2 border-gray-400 bg-white rounded-full px-4 py-2 rounded"
                                            >
                                                ➕ Add
                                            </button>
                                        </div>)}



                                    <div className="flex justify-center fixed bottom-0 left-0 right-0 z-[10] md:relative md:bottom-auto md:left-auto md:right-auto">
                                        <div className="mobile-only-shadow flex items-center justify-between bg-white p-2 rounded-t-xl w-full max-w-[30rem] gap-[0.5rem] mx-auto md:rounded-none md:p-0 md:bg-transparent">
                                            <button
                                                onClick={() => setNextPage(1)}
                                                className="flex items-center justify-center gap-2 bg-[#EE3840] hover:bg-[#d32f2f] text-white text-base font-medium py-3 px-1 rounded-full transition-all w-full"
                                            >
                                                <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/navbar/right-arrow.svg' alt="Continue" className="h-[24px] w-[24px] scale-x-[-1]" />
                                                Back
                                            </button>
                                            <button
                                                onClick={handleContinue}
                                                // onClick={() => setNextPage(3)}

                                                className={`flex items-center justify-center gap-2 text-white text-base font-medium py-3 px-2 rounded-full transition-all w-full 
                                                bg-[#21A6E9] hover:bg-[#1e94d6]`}
                                            >
                                                Continue
                                                <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/navbar/right-arrow.svg' alt="Back" className="h-[24px] w-[24px]" />
                                            </button>


                                            <div className="flex-grow max-w-[5rem] min-w-[1rem]"></div>

                                        </div>
                                    </div>
                                </form>
                            )}
                        </div>
                        )}
                        {nextPage === 3 && (
                            <form className=" font-satoshi max-w-xl mx-auto p-[1.5rem] bg-white rounded-md space-y-4 mb-5 ">

                                <div className="flex  md:flex-row items-center justify-between gap-2 p-2">
                                    <h2 className="text-xl font-semibold text-center my-2">ADD MORE VEHICLES</h2>

                                </div>

                                <div className="mb-[6rem]">
                                    {formData.vehicleNo.length === 0 && vehicleInputs.length === 0 && (
                                        <div className="mb-6">
                                            <p className="text-sm text-black">Enter Vehicle Registration Number</p>
                                            <div
                                                className="flex items-center justify-between px-3 py-1 mt-1 rounded"
                                            >
                                                <input
                                                    type="text"
                                                    autoFocus
                                                    placeholder="eg. HR11BE1234"
                                                    value={inputValue}
                                                    // onChange={(e) => e.target.value.toUpperCase()}
                                                    onChange={(e) => {

                                                        if (e.target.value.trim() === '') {
                                                            showDetailsRef.current.style.display = "none";
                                                        }
                                                        if (vehicleNoRegex.test(e.target.value)) {
                                                            showDetailsRef.current.style.display = "block";
                                                        }
                                                        else {
                                                            showDetailsRef.current.style.display = "none";
                                                        }

                                                        setInputValue(e.target.value.toUpperCase())
                                                    }}
                                                    onBlur={(e) => {
                                                        const value = e.target.value.trim().toUpperCase();
                                                        if (vehicleNoRegex.test(value)) {
                                                            return;
                                                            setIsOpenImage((prev) => ({
                                                                ...Object.fromEntries(Object.keys(prev).map((k) => [k, false])), // Close all
                                                                [value]: true, // Open the new one
                                                            }));
                                                            setFormData((prev) => ({
                                                                ...prev,
                                                                vehicleNo: [...prev.vehicleNo, value],
                                                            }));
                                                            setIsOpenImage((prev) => ({
                                                                ...Object.fromEntries(Object.keys(prev).map((k) => [k, false])),
                                                                [value]: true,
                                                            }));

                                                        } else {
                                                            showError('Invalid Vehicle Number Format');

                                                        }
                                                    }}
                                                    className="text-sm font-semibold text-black px-2 py-1 rounded w-2/3"
                                                />

                                                <div
                                                    style={{ display: 'none' }}
                                                    ref={showDetailsRef}
                                                    onClick={(e) => {
                                                        setIsLoading(true)
                                                        setTimeout(async () => {
                                                            await verifyRC()

                                                        }, 1000);


                                                    }} className="h-[40px] w-[40px] cursor-pointer rounded-full p-2 bg-[#21A6E9]">
                                                    <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/navbar/right-arrow.svg'
                                                        alt="arrow"

                                                        onClick={() => toggleVehicleImage('temp')} className="text-green-600" />

                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    {[...formData.vehicleNo].map((vehicleNo) => (
                                        <div key={vehicleNo} id={`vehicle-section-${vehicleNo}`} className="mb-6">
                                            <Trash2 className='absolute text-red-500 right-6' onClick={() => {
                                                setDeletionVehicle(vehicleNo)
                                                setOpenDeletionModal(true)
                                            }} />
                                            <div
                                                className="flex items-center justify-between  py-1 mt-1 rounded cursor-pointer"
                                                onClick={() => setIsOpenImage((prev) => ({
                                                    ...Object.fromEntries(Object.keys(prev).map((k) => [k, false])),
                                                    [vehicleNo]: !prev[vehicleNo],
                                                }))}
                                            >
                                                <span className="text-black font-semibold">{vehicleNo}</span>

                                                <div className="flex gap-2">
                                                    {/* {isOpenImage[vehicleNo] ? (
                                                    <ChevronDown className="text-black h-6 p-1 bg-gray-200 rounded-full" />
                                                ) : (
                                                    <ChevronUp className="text-black h-6 p-1 bg-gray-200 rounded-full" />
                                                )} */}
                                                </div>
                                            </div>


                                            {isOpenImage[vehicleNo] && (
                                                <div className="mt-2">
                                                    <input
                                                        name={`driverName-${vehicleNo}`}
                                                        value={formData[`driverName-${vehicleNo}`] || ""}
                                                        placeholder="Enter Driver Name"
                                                        onChange={(e) => {
                                                            const { name, value } = e.target;
                                                            setFormData((prev) => ({
                                                                ...prev,
                                                                [name]: value.replace(/[^a-zA-Z\s]/g, "").slice(0, 50).toUpperCase(),
                                                            }));
                                                        }}
                                                        className="border border-[#DEDEE8] bg-[#F6F6F6] rounded pl-3 py-2 w-[95%] m-2"
                                                    />
                                                    <input
                                                        name={`driverNumber-${vehicleNo}`}
                                                        value={formData[`driverNumber-${vehicleNo}`] || ""}
                                                        placeholder="Enter Driver Number"
                                                        onChange={(e) => {
                                                            const { name, value } = e.target;
                                                            setFormData((prev) => ({
                                                                ...prev,
                                                                [name]: value.replace(/\D/g, "").slice(0, 10).toUpperCase(),
                                                            }));
                                                        }}
                                                        className="border border-[#DEDEE8] bg-[#F6F6F6] rounded pl-3 py-2 w-[95%] m-2"
                                                    />
                                                    <input
                                                        name={`driverDLNo-${vehicleNo}`}
                                                        value={formData[`driverDLNo-${vehicleNo}`] || ""}
                                                        placeholder="Enter Driver DL Number"
                                                        onChange={(e) => {
                                                            const name = e.target.name;
                                                            const value = e.target.value.toUpperCase();
                                                            setFormData((prev) => ({
                                                                ...prev,
                                                                [name]: value,
                                                            }));
                                                        }}
                                                        className="border border-[#DEDEE8] bg-[#F6F6F6] rounded pl-3 py-2 w-[95%] m-2"
                                                    />

                                                    <input
                                                        type='date'
                                                        name={`driverDOB-${vehicleNo}`}
                                                        value={formData[`driverDOB-${vehicleNo}`] || ""}
                                                        max={new Date(new Date().setFullYear(new Date().getFullYear() - 18)).toISOString().split("T")[0]} // max date = today - 18 years
                                                        placeholder="Enter Driver DOB"
                                                        onChange={(e) => {
                                                            const name = e.target.name;
                                                            const value = e.target.value.toUpperCase();
                                                            setFormData((prev) => ({
                                                                ...prev,
                                                                [name]: value,
                                                            }));
                                                        }}
                                                        className="border border-[#DEDEE8] bg-[#F6F6F6] rounded pl-3 py-2 w-[95%] m-2"
                                                    />

                                                    {
                                                        `driverName-${vehicleNo}` in formData &&
                                                        `driverNumber-${vehicleNo}` in formData &&
                                                        `driverDLNo-${vehicleNo}` in formData &&
                                                        `driverDOB-${vehicleNo}` in formData &&
                                                        formData[`driverName-${vehicleNo}`]?.trim() !== "" &&
                                                        formData[`driverNumber-${vehicleNo}`]?.trim() !== "" &&
                                                        formData[`driverDLNo-${vehicleNo}`]?.trim() !== "" &&
                                                        formData[`driverDOB-${vehicleNo}`]?.trim() !== "" &&
                                                        <div className="grid grid-cols-2 gap-2 mt-3 p-2 rounded-xl bg-gradient-to-b from-white to-gray-200">
                                                            {imageKeysForVehicle.map((key) => {
                                                                const combinedKey = `${key}-${vehicleNo}`;
                                                                return (
                                                                    <div key={combinedKey} className="flex flex-col relative p-2 rounded-md border-2 border-dotted border-gray-400">
                                                                        {images[combinedKey] ? (
                                                                            <div className="relative w-full h-[9rem] mb-2 rounded-md">
                                                                                {typeof images[combinedKey] === "object" && (
                                                                                    images[combinedKey].type === "application/pdf" ? (
                                                                                        <div className="w-full h-[9rem] rounded-xl bg-gray-100 flex flex-col items-center justify-center text-gray-700">
                                                                                            <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 mb-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 17v-2a2 2 0 012-2h2m4 4v-6a2 2 0 00-2-2h-4l-4 4v6a2 2 0 002 2h4a2 2 0 002-2z" />
                                                                                            </svg>
                                                                                            <span className="text-sm font-medium">PDF Uploaded</span>
                                                                                        </div>
                                                                                    ) : (
                                                                                        <img
                                                                                            src={URL.createObjectURL(images[combinedKey])}
                                                                                            alt={combinedKey}
                                                                                            className="w-full h-[9rem] rounded-xl object-cover"
                                                                                        />
                                                                                    )
                                                                                )}
                                                                                <button
                                                                                    type="button"
                                                                                    onClick={() =>
                                                                                        setImages((prev) => {
                                                                                            const newImages = { ...prev };
                                                                                            delete newImages[combinedKey];
                                                                                            return newImages;
                                                                                        })
                                                                                    }
                                                                                    className="absolute top-0 right-0 bg-white text-red-900 rounded-full w-9 h-9 flex items-center justify-center text-xs hover:bg-red-600"
                                                                                    title="Remove Image"
                                                                                >
                                                                                    <Trash2 />
                                                                                </button>
                                                                            </div>
                                                                        ) : (
                                                                            <div className="flex flex-col items-center justify-center h-24">
                                                                                <button
                                                                                    type="button"
                                                                                    className="bg-gray-600 text-white p-2 rounded-full hover:bg-black"
                                                                                    onClick={() => document.getElementById(`upload-${combinedKey}`).click()}
                                                                                >
                                                                                    <AddIcon />
                                                                                </button>
                                                                                <input hidden
                                                                                    type="file"
                                                                                    id={`upload-${combinedKey}`}
                                                                                    accept="image/*,application/pdf"
                                                                                    className="hidden"
                                                                                    onChange={(e) => handleImageChangeForVehicle([combinedKey], e.target.files[0], inputValue)}

                                                                                />
                                                                            </div>
                                                                        )}
                                                                        <label className="block text-center text-sm mt-2">
                                                                            {key} - {vehicleNo}
                                                                        </label>
                                                                    </div>
                                                                );
                                                            })}
                                                        </div>
                                                    }


                                                </div>
                                            )}
                                        </div>
                                    ))}


                                    {showVehicleInput && (
                                        <div>
                                            <p className="text-sm text-black mr-3 mt-[2rem] mb-0">Enter Vehicle Registration Number</p>
                                            <div className="flex items-center justify-between  py-1 mt-1 rounded">
                                                <input
                                                    type="text"
                                                    autoFocus
                                                    placeholder="eg. HR11BE1234"
                                                    value={inputValue}
                                                    // onChange={(e) => setInputValue(e.target.value.toUpperCase())}
                                                    onChange={(e) => {

                                                        if (e.target.value.trim() === '') {
                                                            showDetailsRef.current.style.display = "none";
                                                        }
                                                        if (vehicleNoRegex.test(e.target.value)) {
                                                            showDetailsRef.current.style.display = "block";
                                                        }
                                                        else {
                                                            showDetailsRef.current.style.display = "none";
                                                        }

                                                        setInputValue(e.target.value.toUpperCase())
                                                    }}
                                                    onBlur={(e) => {
                                                        return
                                                        const value = e.target.value.trim().toUpperCase();
                                                        if (vehicleNoRegex.test(value)) {
                                                            setIsOpenImage((prev) => ({
                                                                ...Object.fromEntries(Object.keys(prev).map((k) => [k, false])), // Close all
                                                                [value]: true, // Open the new one
                                                            }));
                                                            setFormData((prev) => ({
                                                                ...prev,
                                                                vehicleNo: [...prev.vehicleNo, value],
                                                            }));
                                                            setIsOpenImage({ [value]: true });
                                                            setShowVehicleInput(false);
                                                            setInputValue('');
                                                        } else {
                                                            showError('Invalid Vehicle Number Format');

                                                        }
                                                    }}
                                                    className="text-sm font-semibold text-black px-2 py-1 rounded w-2/3 uppercase"
                                                />
                                                {/* <CheckCircleIcon className="text-green-600" /> */}
                                                {/* <div className="h-[40px] w-[40px] cursor-pointer rounded-full p-2 bg-[#21A6E9]">
                                                    <img src={rightArrow}
                                                        alt="arrow"
                                                        className="text-green-600" />

                                                </div> */}

                                                <div
                                                    style={{ display: 'none' }}
                                                    ref={showDetailsRef}
                                                    onClick={(e) => {
                                                        setIsLoading(true)
                                                        setTimeout(async () => {
                                                            await verifyRC()

                                                        }, 1000);


                                                    }} className="h-[40px] w-[40px] cursor-pointer rounded-full p-2 bg-[#21A6E9]">
                                                    <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/navbar/right-arrow.svg'
                                                        alt="arrow"

                                                        onClick={() => toggleVehicleImage('temp')} className="text-green-600" />

                                                </div>

                                            </div>
                                        </div>

                                    )}


                                    {formData.vehicleNo.length !== 0 && (
                                        <div className="fixed bottom-[6rem] right-4 z-50">
                                            <button
                                                type="button"
                                                onClick={() => {
                                                    if (!canAddNewVehicle()) {
                                                        showError('Please complete driver info and upload all images before adding a new vehicle.');
                                                        return;
                                                    }
                                                    setShowVehicleInput(true);
                                                    setIsOpenImage({});
                                                    setInputValue('')
                                                }}
                                                className=" border-2 border-gray-400 bg-white rounded-full px-4 py-2 rounded"
                                            >
                                                ➕ Add More Vehicles
                                            </button>
                                        </div>)}

                                    {showPopup && (
                                        <div className="fixed top-5 text-center  transform -translate-x-1 bg-red-500 text-white px-4 py-2 rounded shadow z-50">
                                            {popupMessage}
                                        </div>
                                    )}


                                </div>

                                {
                                    alertInfo.show && (
                                        <Alert severity={alertInfo.severity} onClose={() => setAlertInfo({ ...alertInfo, show: false })}>
                                            {alertInfo.message}
                                        </Alert>
                                    )
                                }

                                <div className="flex justify-center fixed bottom-0 left-0 right-0 z-[10] md:relative md:bottom-auto md:left-auto md:right-auto" >
                                    <div className="mobile-only-shadow flex items-center justify-between bg-white p-2 rounded-t-xl w-full max-w-[30rem] gap-[0.5rem] mx-auto md:rounded-none md:p-0 md:bg-transparent">
                                        <button
                                            type="button"
                                            onClick={canGoBack}
                                            className="flex items-center justify-center gap-2 bg-[#EE3840] hover:bg-[#d32f2f] text-white text-base font-medium py-3 px-1 rounded-full transition-all w-full"
                                        >
                                            <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/navbar/right-arrow.svg' alt="Continue" className="h-[24px] w-[24px] scale-x-[-1]" />
                                            Back
                                        </button>
                                        <button
                                            onClick={readyToSubmit}
                                            className={`flex items-center justify-center gap-2 text-white text-base font-medium py-3 px-2 rounded-full transition-all w-full 
                                            bg-[#21A6E9] hover:bg-[#1e94d6]`}
                                        >
                                            {isSubmitting ? (
                                                <div className="flex gap-2">
                                                    <ClipLoader size={20} color="#ffffff" />
                                                    <p className="mb-0">Submitting...</p>
                                                </div>
                                            ) : (
                                                "Submit"
                                            )}
                                            <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/navbar/right-arrow.svg' alt="Back" className="h-[24px] w-[24px]" />
                                        </button>

                                        <div className="flex-grow max-w-[5rem] min-w-[1rem]"></div>

                                    </div>
                                </div>
                            </form>
                        )}
                    </div>



                    {isSubmitting && (
                        <div className="fixed inset-0 z-[9999] bg-gray-100 bg-opacity-80 flex items-center justify-center">
                            <div className="loader2 h-[50px] w-[20px]"></div>
                        </div>
                    )}
                    <Modal
                        isOpen={isModalOpen}
                        onClose={() => setIsModalOpen(false)}
                        setTypeOfAgreement={setTypeOfAgreement}
                    />
                    <ConfirmationModal
                        isOpen={openConfirmationModal}
                        onClose={() => setOpenConfirmationModal(false)}
                        handleSubmit={handleSubmit}
                    />
                    <ConfirmationGoBackModal
                        isOpen={openConfirmationGoBackModal}
                        onClose={() => setOpenConfirmationGoBackModal(false)}
                        handleSubmit={handleSubmit}
                    />
                    <ValidationFailedModal
                        isOpen={openValidationModal}
                        onClose={() => setOpenValidationModal(false)}
                    />
                    <ConfirmationForDeletion
                        isOpen={openDeletionModal}
                        onClose={() => setOpenDeletionModal(false)}
                        deletionVehicle={deletionVehicle}
                        wantToGoBack={wantToGoBack}
                        deleteVehicle={deleteVehicle}
                    />
                </div>
                <div className=' hidden sm:block w-full mt-[5rem] p-5 max-w-[555px]'>
                    <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/add/img6.png' className='w-[400px] h-[400px]' alt="" />
                </div>
            </div>
            <AnimatePresence>
                {showDetails && (
                    <motion.div
                        initial={{ opacity: 0, y: 50 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: 50 }}
                        transition={{ duration: 0.4 }}
                        className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-50 z-50 flex justify-center items-center"
                        onClick={() => setShowDetails(false)} // Close on outside click
                    >
                        <div
                            className="relative w-[90%] max-w-3xl bg-white rounded-2xl shadow-xl p-6 overflow-y-auto max-h-[90vh]"
                            onClick={(e) => e.stopPropagation()} // Prevent close on inside click
                        >
                            {/* Close Button */}
                            <button
                                onClick={() => setShowDetails(false)}
                                className="absolute top-4 right-4 text-gray-500 hover:text-black transition"
                            >
                                <X size={24} />
                            </button>

                            <h2 className="text-xl font-semibold mb-4 font-satoshi text-[#000]">Vehicle Details</h2>

                            <div className="grid grid-cols-2 md:grid-cols-2 gap-4">
                                {/* Chassis No */}
                                <div>
                                    <label className="font-satoshi font-[500] text-[16px] text-[#000] mb-1">
                                        <span className="flex items-center gap-1">
                                            <FileText size={16} />
                                            Chassis No
                                        </span>
                                    </label>
                                    <div className="flex items-center gap-2 border-b-2 border-black pb-1">
                                        <input
                                            readOnly
                                            value={formData.chassisNo}
                                            className="bg-transparent pl-5 w-full text-[#515151] outline-none font-satoshi"
                                        />
                                    </div>
                                </div>

                                {/* Engine No */}
                                <div>
                                    <label className="font-satoshi font-[500] text-[16px] text-[#000] mb-1">
                                        <span className="flex items-center gap-1">
                                            <Truck size={16} />
                                            Engine No
                                        </span>
                                    </label>
                                    <div className="flex items-center gap-2 border-b-2 border-black pb-1">
                                        <input
                                            readOnly
                                            value={formData.engineNo}
                                            className="bg-transparent pl-5 w-full text-[#515151] outline-none font-satoshi"
                                        />
                                    </div>
                                </div>

                                {/* Make */}
                                <div>
                                    <label className="font-satoshi font-[500] text-[16px] text-[#000] mb-1">
                                        <span className="flex items-center gap-1">
                                            <Box size={16} />
                                            Make
                                        </span>
                                    </label>
                                    <div className="flex items-center gap-2 border-b-2 border-black pb-1">
                                        <input
                                            readOnly
                                            value={formData.make}
                                            className="bg-transparent pl-5 w-full text-[#515151] outline-none font-satoshi"
                                        />
                                    </div>
                                </div>

                                {/* Model */}
                                <div>
                                    <label className="font-satoshi font-[500] text-[16px] text-[#000] mb-1">
                                        <span className="flex items-center gap-1">
                                            <Box size={16} />
                                            Model
                                        </span>
                                    </label>
                                    <div className="flex items-center gap-2 border-b-2 border-black pb-1">
                                        <input
                                            readOnly
                                            value={formData.model}
                                            className="bg-transparent pl-5 w-full text-[#515151] outline-none font-satoshi"
                                        />
                                    </div>
                                </div>

                                {/* Year */}
                                <div>
                                    <label className="font-satoshi font-[500] text-[16px] text-[#000] mb-1">
                                        <span className="flex items-center gap-1">
                                            <Calendar size={16} />
                                            Year
                                        </span>
                                    </label>
                                    <div className="flex items-center gap-2 border-b-2 border-black pb-1">
                                        <input
                                            readOnly
                                            value={formData.year}
                                            className="bg-transparent pl-5 w-full text-[#515151] outline-none font-satoshi"
                                        />
                                    </div>
                                </div>

                                {/* GVW */}
                                <div>
                                    <label className="font-satoshi font-[500] text-[16px] text-[#000] mb-1">
                                        <span className="flex items-center gap-1">
                                            <Shield size={16} />
                                            GVW
                                        </span>
                                    </label>
                                    <div className="flex items-center gap-2 border-b-2 border-black pb-1">
                                        <input
                                            readOnly
                                            value={formData.GVW}
                                            className="bg-transparent pl-5 w-full text-[#515151] outline-none font-satoshi"
                                        />
                                    </div>
                                </div>

                                {/* Insurer Name */}
                                <div>
                                    <label className="font-satoshi font-[500] text-[16px] text-[#000]">
                                        <span className="flex items-center gap-1">
                                            <FileText size={16} />
                                            Insurer Name
                                        </span>
                                    </label>
                                    <div className="flex items-center gap-2 border-b-2 border-black pb-1">
                                        <input
                                            readOnly
                                            value={formData.InsuranceName}
                                            className="bg-transparent pl-5 w-full text-[#515151] outline-none font-satoshi"
                                        />
                                    </div>
                                </div>

                                {/* Insurance Valid Upto */}
                                <div>
                                    <label className="font-satoshi font-[500] text-[16px] text-[#000]">
                                        <span className="flex items-center gap-1">
                                            <Calendar size={16} className="inline-block mr-1" />
                                            Insurance Valid Upto
                                        </span>
                                    </label>
                                    <div className="flex items-center gap-2 border-b-2 border-black pb-1">
                                        <input
                                            readOnly
                                            value={formData.InsuranceValidUpto}
                                            className="bg-transparent pl-5 w-full text-[#515151] outline-none font-satoshi"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </motion.div>
                )}

            </AnimatePresence>
        </div>


    );
};

export default AddNewVehicleDetails;


function Modal({ isOpen, onClose, setTypeOfAgreement }) {
    if (!isOpen) return null;
    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[1000]">
            <div className="bg-white py-[42px] px-[50px] rounded-[30px] shadow-lg w-[90%] md:w-[536px] relative">
                <h6 className="m-0 font-[500] text-[14px] md:text-[18px] font-satoshi text-center text-[#000000]">Please Choose The Type Of Vendor</h6>
                <div className="grid md:grid-cols-2 grid-cols-1 pt-[40px] items-center gap-[18px]">
                    <div
                        onClick={() => {
                            setTypeOfAgreement('individual')
                            onClose();
                        }}
                        className="bg-[#EE3840] flex py-[5px] rounded-full pr-[6px] pl-[26px] w-full justify-between items-center cursor-pointer">
                        <button className="font-satoshi font-[400] text-[18px] leading-[33.6px] pr-[36px] text-[#FFFFFF]">Individual</button>
                        <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/navbar/right-arrow.svg' className="h-[30px] w-[30px]" alt="" />
                    </div>
                    <div onClick={() => {
                        setTypeOfAgreement('non-individual')
                        onClose();
                    }} className="bg-[#21A6E9] flex py-[5px] rounded-full pr-[6px] pl-[26px] w-full cursor-pointer justify-between items-center">
                        <button className="font-satoshi font-[400] text-[18px] leading-[33.6px] text-[#FFFFFF]">Company</button>
                        <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/navbar/right-arrow.svg' className="h-[30px] w-[30px]" alt="" />
                    </div>
                </div>
            </div>
        </div>
    );
};

function ConfirmationGoBackModal({ isOpen, onClose, handleSubmit }) {
    const navigate = useNavigate();

    if (!isOpen) return null;
    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-lg p-6 w-80 text-center">
                <h2 className="text-lg font-semibold mb-2"> Exit with Adding Vehicles?</h2>
                <p className="text-gray-600 text-sm mb-6">
                    Are you sure you want to go back?
                </p>
                <div className="flex justify-around text-sm">
                    <button
                        className="text-gray-700 hover:underline"
                        onClick={onClose}
                    >
                        Cancel
                    </button>
                    <button
                        className="text-blue-600 hover:underline font-medium"
                        onClick={() => {
                            onClose();
                            navigate('/AllAddedVehiclesNew');
                        }}
                    >
                        Confirm
                    </button>
                </div>
            </div>
        </div>)
}


function ConfirmationModal({ isOpen, onClose, handleSubmit }) {
    const navigate = useNavigate();

    if (!isOpen) return null;
    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-lg p-6 w-80 text-center">
                <h2 className="text-lg font-semibold mb-2"> Confirmation of Submission?</h2>
                <p className="text-gray-600 text-sm mb-6">
                    Are you sure you want to submit? You will not be able to change Details later.
                </p>
                <div className="flex justify-around text-sm">
                    <button
                        className="text-gray-700 hover:underline"
                        onClick={onClose}
                    >
                        Cancel
                    </button>
                    <button
                        className="text-blue-600 hover:underline font-medium"
                        onClick={() => {
                            onClose();
                            handleSubmit();
                            // navigate('/AllAddedVehiclesNew');
                        }}
                    >
                        Confirm
                    </button>
                </div>
            </div>
        </div>)
}

function ConfirmationForDeletion({ isOpen, onClose, deleteVehicle, deletionVehicle, wantToGoBack }) {
    if (!isOpen) return null;
    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-lg p-6 w-80 text-center">
                <h2 className="text-lg font-semibold mb-2 text-red-500"> Delete Added Vehicle</h2>
                <p className="text-gray-600 text-sm mb-6">
                    Are you sure you want to Delete? {wantToGoBack ? 'And Lost Last Half Filled Details ?' : ''}
                </p>
                <div className="flex justify-around text-sm">
                    <button
                        className="text-gray-700 hover:underline"
                        onClick={onClose}
                    >
                        Cancel
                    </button>
                    <button
                        className="text-blue-600 hover:underline font-medium"
                        onClick={() => {
                            onClose();
                            deleteVehicle(deletionVehicle)
                        }}
                    >
                        Confirm
                    </button>
                </div>
            </div>
        </div>)
}

function ValidationFailedModal({ isOpen, onClose }) {
    if (!isOpen) return null;

    return (
        <div className="font-satoshi fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-lg p-6 w-80 text-left">
                <p className="text-gray-600 text-sm mb-6">
                    <span className="text-red-600">*</span> Please complete all required fields and upload necessary images before submitting the form.
                </p>
                <div className="flex justify-end">
                    <button
                        className="border-2 border-[#21A6E9] bg-white hover:bg-blue-600  py-1 px-6 rounded"
                        onClick={onClose}
                    >
                        Okay
                    </button>
                </div>
            </div>
        </div>
    );
}
